import {useEffect, useState} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import {useLocation, useNavigate} from "react-router-dom";
import Api from "../../tools/service";
import LoadingScreen from "../../components/LoadingScreen";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/Authentication";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import CreatePayment from "../../components/authentication/CreatePayment";
import NIDCardReader from "../../components/authentication/NIDCardReader";
import CompareFaces from "../../components/authentication/CompareFaces";
import {StreamManager} from "../../tools/contexts/StreamManager";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import VideoValidation from "../../components/authentication/VideoValidation";
import Final from "../../components/authentication/Final";
import Widget from "../../components/authentication/Widget";
import InitConfirm from "../../components/authentication/InitConfirm";
import BusinessLicenseInquiry from "../../components/authentication/BusinessLicenseInquiry";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import ReportedCard from "../../components/authentication/ReportedCard";
import BusinessLicenseOTP from "../../components/authentication/businessLicense/BusinessLicenseOTP";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import NewSelectItems from "../../components/authentication/newSelectItems";
import useDivarAuth from "../../hooks/useDivarAuth";

const Authentication = () => {
    const {token,returnUrl,serviceType,postToken}=useDivarAuth();
    const navigate = useNavigate()
    const {state} = useLocation();
    const redirectFromPayment = state ? state.redirectFromPayment : null
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        isActive: false,
        message: 'دریافت اطلاعات'
    });
    const [process, setProcess] = useState(null);
    const [components, setComponents] = useState(null);
    const [widget, setWidget] = useState(null);
    const [reported, setReported] = useState(false);
    const [reportedMessage, setReportedMessage] = useState('');
    useEffect(() => {
        handleInquiryProcess()
    }, []);
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        });
        safeRedirect(link, () => {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: 'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText: 'بستن',
                onCancel: () => {
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })

    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }
    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleCreateProcess = () => {
        setIsLoading({
            isActive: true,
            message: 'در حال ساخت فرایند'
        })
        Api.post(REQUEST_URLS.AUTHENTICATION.CREATE_PROCESS, {
            "post_token": postToken,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading({
                    isActive: false,
                    message: 'در حال ساخت فرایند'
                })
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleCreateProcess();
                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    isActive: true,
                    message: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setIsLoading({
            isActive: true,
            message: 'در حال دریافت اطلاعات'
        })
        setWidget(null);
        Api.get(REQUEST_URLS.AUTHENTICATION.INQUIRY_PROCESS, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            params: {
                post_token:postToken,
                service_type:serviceType
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    isActive: false,
                    message: 'در حال دریافت اطلاعات'
                })
                handleError({
                    status,
                    message,
                    data,

                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    if (data?.widget && data?.widget?.has_widget && (data.widget?.available_services.length > data.widget?.deleted_widgets.length)) {
                        if (data?.components?.current_component.name !== "Final") {
                            setPid(data.process.pid);
                            if (redirectFromPayment) {
                                handleGetProcess(data.process.pid)
                            } else {
                                setIsLoading({
                                    isActive: false,
                                    message: 'در حال دریافت اطلاعات'
                                })
                                setWidget(data?.widget);
                            }
                        } else {
                            setIsLoading({
                                isActive: false,
                                message: 'در حال دریافت اطلاعات'
                            })
                            setWidget(data?.widget);

                        }

                    } else {
                        if (data?.components?.current_component.name !== "Final") {
                            setPid(data.process.pid);
                            handleGetProcess(data.process.pid)
                        } else {
                            handleCreateProcess();
                        }

                    }
                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleShahkar = (newPid) => {

        setIsLoading({
            isActive: true,
            message: 'در حال تطبیق کد ملی و شماره موبایل'
        })
        handleGenerateUuid('Shahkar', token).then(data => {
            setIsLoading({
                isActive: true,
                message: 'در حال تطبیق کد ملی و شماره موبایل'
            })
            Api.post(REQUEST_URLS.AUTHENTICATION.SHAHKAR, {
                pid: newPid,
                uuid: data,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        isActive: false,
                        message: 'در حال تطبیق کد ملی و شماره موبایل'
                    })
                    if (status === 360) {

                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showConfirmButton: data?.can_reset,
                            confirmButtonText: 'ویرایش اطلاعات',
                            confirmButtonTheme: "light",
                            showCancelButton: !data?.can_reset,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            pid: newPid,
                            onConfirm: () => {
                                if (data.can_reset) {
                                    handleReset(newPid);
                                }
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                Reoverlay.hideModal();
                                handleShahkar(newPid);
                            }
                        })
                    } else {
                        handleError({
                            message,
                            status,
                            data,
                            callback: () => {

                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message: message || 'خطای دسترسی',
                                    showConfirmButton: data?.can_reset,
                                    confirmButtonText: 'ویرایش اطلاعات',
                                    confirmButtonTheme: "light",
                                    showCancelButton: true,
                                    cancelButtonText: 'تلاش مجدد',
                                    cancelButtonTheme: 'red',
                                    pid: newPid,
                                    onConfirm: () => {
                                        if (data.can_reset) {
                                            handleReset(newPid);
                                        }
                                        Reoverlay.hideModal();
                                    },
                                    onCancel: () => {
                                        Reoverlay.hideModal();
                                        handleShahkar(newPid);
                                    }
                                })
                            }
                        })
                    }


                }

            }).catch(() => {
                setIsLoading({
                    isActive: false,
                    message: 'در حال تطبیق کد ملی و شماره موبایل'
                })

            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);
            setIsLoading({
                isActive: false,
                message: 'در حال تطبیق کد ملی و شماره موبایل'
            })
        });

    }
    const handleAutoAuth = (newPid) => {
        Api.post(REQUEST_URLS.AUTHENTICATION.AUTO_I_AUTH, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, message, data, status} = response;
            if (hasError) {
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleAutoAuth(newPid);
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        })
    }
    const handleAutoNIDCard = (newPid) => {

        setIsLoading({
            isActive: true,
            message: 'در حال دریافت اطلاعات'
        })

        handleGenerateUuid('AutoNIDCard', token).then(uuid => {

            setIsLoading({
                isActive: true,
                message: 'در حال دریافت اطلاعات هویتی'
            })
            Api.post(REQUEST_URLS.AUTHENTICATION.AUTO_NID_CARD, {
                pid: newPid,
                uuid: uuid,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        isActive: false,
                        message: 'در حال دریافت اطلاعات هویتی'
                    })
                    if (status === 512) {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: data?.can_reset,
                            confirmButtonText: 'ویرایش اطلاعات',
                            confirmButtonTheme: "light",
                            showCancelButton: !data?.can_reset,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            pid: newPid,
                            onConfirm: () => {
                                if (data.can_reset) {
                                    handleReset(newPid);
                                }
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                Reoverlay.hideModal();
                                handleAutoNIDCard(newPid);
                            }
                        })

                    } else {
                        handleError({
                            message,
                            status,
                            data,
                            callback: () => {
                                Reoverlay.showModal(ErrorModal, {
                                    title: 'خطا',
                                    message: message || 'خطای دسترسی',
                                    showConfirmButton: data?.can_reset,
                                    confirmButtonText: 'ویرایش اطلاعات',
                                    confirmButtonTheme: "light",
                                    showCancelButton: true,
                                    cancelButtonText: 'تلاش مجدد',
                                    cancelButtonTheme: 'red',
                                    pid: newPid,
                                    onConfirm: () => {
                                        if (data.can_reset) {
                                            handleReset(newPid);
                                        }
                                        Reoverlay.hideModal();
                                    },
                                    onCancel: () => {
                                        Reoverlay.hideModal();
                                        handleAutoNIDCard(newPid);
                                    }
                                })
                            }
                        })
                    }


                }

            }).catch(() => {
                setIsLoading({
                    isActive: false,
                    message: 'در حال دریافت اطلاعات هویتی'
                })
            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);

            setIsLoading({
                isActive: false,
                message: 'در حال دریافت اطلاعات'
            })
        });
    }
    const handleGetProcess = (newPid) => {
        setIsLoading({
            isActive: true,
            message: 'در حال دریافت اطلاعات'
        })
        Api.get(REQUEST_URLS.AUTHENTICATION.FETCH_PROCESS, {
            params: {
                pid: newPid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {

                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleGetProcess(newPid);
                            }
                        })
                    }
                })
            } else {
                setComponents(data.components)
                setProcess(data.process);
                if (data?.process?.has_verified_auth && data.components.current_component.name !== AuthenticationDefaultSteps.FINAL) {
                    handleAutoAuth(newPid)
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.AUTO_NID_CARD) {
                    handleAutoNIDCard(newPid)
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.SHAHKAR) {
                    handleShahkar(newPid);
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.EXPERT_INQUIRY) {
                    handleExpertInquiry(newPid);
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.LAWYER_INQUIRY) {
                    handleLawyerInquiry(newPid);
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.POLICE_CLEARANCE_INQUIRY) {
                    handlePoliceClearanceInquiry(newPid);
                } else {
                    setIsLoading({
                        isActive: false,
                        message: 'در حال دریافت اطلاعات'
                    })
                }

            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleError = ({onConfirm, onClose, message, title, pid, data, status, options, callback}) => {
        if (status === -9) {
            //rate limit error
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'بازگشت به دیوار',
                confirmButtonTheme: "red",
                onConfirm: () => {
                    const price = process?.payment?.info ? process.payment?.info?.init_amount : 0
                    handleRedirectToDivar({
                        price: price,
                        status: 'fail',
                    });
                }
            })
        } else if (status === -20) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: false,
            })
        } else if (status === -10) {
            setReported(true)
            setReportedMessage(message)
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {


                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    navigate('/auth/gate/v11dW62X4kaZ2Hn4/' +serviceType + '?post_token=' + postToken)

                }
            })
        }/*else if(data && data?.can_reset){
            handleReset(pid)
        }*/ else if (status === 801 || status === 802 || status === 803 || status === 805 || status === -100) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }
    const handleSkip = (newPid) => {

        setIsLoading({
            isActive: true,
            message: 'در حال رد کردن مرحله فعلی'
        })
        Api.post(REQUEST_URLS.AUTHENTICATION.SKIP_STEP, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                setIsLoading({
                    isActive: false,
                    message: 'در حال دریافت اطلاعات'
                })
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            pid: newPid,
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleSkip(newPid);
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    const handleReset = (newPid) => {
        setIsLoading({
            isActive: true,
            message: 'در حال بازگشت به مرحله تکمیل اطلاعات'
        })
        Api.post(REQUEST_URLS.AUTHENTICATION.RESET_PROCESS, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleReset(newPid);
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    const handleLawyerInquiry = (newPid) => {
        setIsLoading({
            isActive: true,
            message: 'در حال استعلام پروانه وکالت'
        })
        handleGenerateUuid("LawyerInquiry", token).then(uuid => {
            Api.post(REQUEST_URLS.AUTHENTICATION.LAWYER_INQUIRY, {
                uuid: uuid,
                pid: newPid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {
                const {hasError, data, message, status} = response;
                if (hasError) {
                    setIsLoading({
                        isActive: false,
                        message: 'در حال استعلام پروانه وکالت'
                    })
                    handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data.can_skip) {
                                        handleSkip(newPid)
                                    } else {

                                    }
                                },
                                confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                                confirmButtonTheme: "green",
                                showConfirmButton: data.can_skip ? data.can_skip : false,
                                showCancelButton: true,
                                cancelButtonText: data.can_reset ? 'ویرایش اطلاعات' : 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onCancel: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid)
                                    } else {
                                        handleLawyerInquiry(newPid)
                                    }
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                } else {
                    handleGetProcess(pid)
                }
            }).catch(e => {

            })
        })
    }
    const handlePoliceClearanceInquiry = (newPid) => {
        setIsLoading({
            isActive: true,
            message: 'در حال استعلام سوء پیشینه'
        })
        handleGenerateUuid("PoliceClearanceInquiry", token).then(uuid => {
            Api.post(REQUEST_URLS.AUTHENTICATION.POLICE_CLEARANCE_INQUIRY, {
                uuid: uuid,
                pid: newPid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {
                const {hasError, data, message, status} = response;
                if (hasError) {
                    setIsLoading({
                        isActive: false,
                        message: 'در حال استعلام سوء پیشینه'
                    })


                    handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data.can_skip) {
                                        handleSkip(newPid)
                                    } else {

                                    }
                                },
                                confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                                confirmButtonTheme: "green",
                                showConfirmButton: data.can_skip ? data.can_skip : false,
                                showCancelButton: true,
                                cancelButtonText: data.can_reset ? 'ویرایش اطلاعات' : 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onCancel: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid)
                                    } else {
                                        handlePoliceClearanceInquiry(newPid)
                                    }
                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                } else {
                    handleGetProcess(newPid)
                }
            }).catch(e => {

            })
        })
    }
    const handleExpertInquiry = (newPid) => {

        setIsLoading({
            isActive: true,
            message: 'در حال استعلام پروانه کارشناسی'
        })
        handleGenerateUuid("ExpertInquiry", token).then(uuid => {
            Api.post(REQUEST_URLS.AUTHENTICATION.EXPERT_INQUIRY, {
                uuid: uuid,
                pid: newPid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {
                const {hasError, data, message, status} = response;
                if (hasError) {

                    setIsLoading({
                        isActive: false,
                        message: 'در حال استعلام پروانه کارشناسی'
                    })
                    handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data.can_skip) {
                                        handleSkip(newPid)
                                    } else {

                                    }
                                },
                                confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                                showConfirmButton: data.can_skip ? data.can_skip : false,
                                showCancelButton: true,
                                confirmButtonTheme: "green",
                                cancelButtonText: data.can_reset ? 'ویرایش اطلاعات' : 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onCancel: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    } else {
                                        handleExpertInquiry(newPid)
                                    }

                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                } else {
                    handleGetProcess(pid)
                }
            }).catch(e => {

            })
        });
    }
    const handleResultMessage = () => {
        let message = "";
        if (components?.current_component?.name === AuthenticationDefaultSteps.POLICE_CLEARANCE_RESULT) {
            if (process.is_police_user_add_on) {
                if (process.is_police_periodic) {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه نهایتا تا 7 الی 10 روز کاری روی آگهی‌های شما درج خواهد شد."
                } else if (process.has_police_inquiry) {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه نهایتا تا 24 ساعت کاری روی آگهی‌های شما درج خواهد شد."
                } else {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه تا 2 الی 3 روز کاری آینده روی آگهی‌های شما درج خواهد شد."
                }
            } else {
                if (process.is_police_periodic) {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه نهایتا تا 7 الی 10 روز کاری روی آگهی شما درج خواهد شد."
                } else if (process.has_police_inquiry) {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه نهایتا تا 24 ساعت کاری روی آگهی‌ شما درج خواهد شد."
                } else {
                    message = "احراز هویت با موفقیت انجام شد. افزونه مربوط به عدم سوء پیشینه تا 2 الی 3 روز کاری آینده روی آگهی‌شما درج خواهد شد."
                }

            }
        } else if (components?.current_component?.name === AuthenticationDefaultSteps.FINAL) {
            if (process.is_police_user_add_on || process.is_user_add_on) {
                message = "احراز هویت با موفقیت انجام شد. افزونه احراز هویت روی آگهی درج شد."
            } else {
                message = "احراز هویت با موفقیت انجام شد. افزونه احراز هویت روی آگهی‌های شما درج شد."
            }
        }
        return message;
    }
    return <>
        <AuthenticationServiceContext.Provider value={
            {
                postToken,
                isLoading,
                pid,
                token,
                process,
                components,
                handleInquiryProcess,
                handleLoading,
                handleUpdateStep,
                handleProcess,
                handleError,
                handleComponents,
                handleGetProcess,
                handleCreateProcess,
                handleSkip,
                handleReset,
                handleRedirectToDivar,


            }
        }>
            {reported && <ReportedCard reportedMessage={reportedMessage}/>}
            {!reported && <div className="min-h-screen">
                {widget && !process && <Widget handleInquiryProcess={handleInquiryProcess} widget={widget}/>}
                {isLoading && isLoading.isActive && <LoadingScreen text={isLoading.message}/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.SET_ITEMS &&
                    <NewSelectItems/>
                }
                {process && process?.init_confirm_inputs && components?.current_component?.name === AuthenticationDefaultSteps.INIT_CONFIRM &&
                    <InitConfirm/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.CREATE_PAYMENT &&
                    <CreatePayment/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.PAYMENT_INQUIRY &&
                    <CreatePayment/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.BUSINESS_OTP &&
                    <BusinessLicenseOTP/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.BUSINESS_LICENSE_INQUIRY &&
                    <BusinessLicenseInquiry/>}
                <StreamManager>
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.NID_CARD_READER &&
                        <NIDCardReader/>}
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.COMPARE_FACES &&
                        <CompareFaces/>}
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.VIDEO_VALIDATION &&
                        <VideoValidation/>}
                </StreamManager>
                {process && components?.current_component?.name === AuthenticationDefaultSteps.POLICE_CLEARANCE_RESULT &&
                    <Final isDisableTitle={true} message={handleResultMessage()}/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.FINAL && <Final/>}

            </div>}
        </AuthenticationServiceContext.Provider>
    </>

}

export default Authentication;